import { Component, OnInit, AfterViewInit } from '@angular/core';

@Component({
  selector: 'kts-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, AfterViewInit {

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
  }
  goToSite(siteValue) {
    switch (siteValue) {
      case 0:

        break;
      case 1:

        break;
      case 2:

        break;

      default:
        break;
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/Yi-Yu/Documents/Actual Documents/Katiso/katiso/src/app/components/footer/footer.component.ts